/**
 * answer-edit-weather.js
 */

import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Types } from 'utils/constants';
import useRecordStore from 'contexts/record-store';
import WeatherEdit from 'components/weather/edit';


export default function AnswerEditWeather(props) {
  const {
    storedRecord,
    drawerState,
    translation,
    workMode,
    date,
    location,
    formPrefix = '',
  } = props;
  const { control } = useFormContext();
  const wasPerformedValue = useWatch({ control, name: `${formPrefix}wasExercisePerformed` });
  const recordStore = useRecordStore();
  const eventRecord = recordStore.useRecord(Types.Record.EVENT, storedRecord.eventId);
  const patrolTypes = storedRecord.patrol?.patrolTypes || [];


  // weather only shown for detection, human/evidence search, tracking
  if (workMode === Types.WorkMode.DETECTION 
    || patrolTypes.find(pt => 
      pt.type === Types.Patrol.EVIDENCE_SEARCH
      || pt.type === Types.Patrol.HUMAN_SEARCH
      || pt.type === Types.Patrol.TRACKING)
  ) {

    return (
      <>
        {wasPerformedValue && (storedRecord.weather || eventRecord.get() || (date && location)) && 
        <WeatherEdit
          name={`${formPrefix}weather`}
          drawerState={drawerState}
          translation={translation}
          location={location || eventRecord.get().location}
          datetime={date || eventRecord.get().date}
        />}
      </>
    );
  }

  return null;
}